<script setup>
import { inject, computed, defineProps } from 'vue';

const props = defineProps({
    // ページID
    pageId: {
        type: String,
        default: ''
    },
    // サイトマップのこのページのデータ
    pageData: {
        type: Object,
        default: {}
    },
    // 背景画像があるかどうか
    background: {
        type: Boolean,
        default: true
    },
});

const mq = inject(['mq']);

// デバイス判定
const device = computed(() => mq.mdPlus ? 'pc' : 'sp');

// 背景画像のURL
const bgUrl = computed(() => {
    if (props.background) {
        return `url('/assets/img${props.pageData.url}mv_${device.value}.webp'`;
    } else {
        return 'none';
    }
});

// 英字タイトル
const titEn = computed(() => {
    let r = props.pageData.name;
    
    // CAFE＆RESTAURANT
    if (props.pageId === 'toka') {
        r = r.replace('CAFE & ', 'CAFE & <br class="md-none">');
    }
    return r;
});
</script>

<template>
<div class="pagetit" :class="{'is-no-bg': !background}" :style="`background-image: ${bgUrl});`">
    <h1 class="sec-tit is-center is-sm-large wow animate__fadeIn" :class="{'is-w': background}">
        <span class="sec-tit__en" v-html="titEn"></span>
        <span class="sec-tit__ja">{{ pageData.nameJa }}</span>
    </h1>
</div>
</template>